import * as i0 from '@angular/core';
import { input, output, Component, InjectionToken, inject, EventEmitter, Injectable, Inject, ChangeDetectorRef, ViewEncapsulation, Injector, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { userIcon, gearIcon, logoutIcon, menuIcon, undoIcon } from '@progress/kendo-svg-icons';
import * as i2 from '@progress/kendo-angular-buttons';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import * as i1 from '@progress/kendo-angular-dialog';
import { DialogService, DialogCloseResult, DialogModule } from '@progress/kendo-angular-dialog';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i2$1 from '@progress/kendo-angular-menu';
import { MenuModule } from '@progress/kendo-angular-menu';
import * as i3 from '@progress/kendo-angular-icons';
import { IconModule, SVGIconModule } from '@progress/kendo-angular-icons';
import * as i2$2 from '@progress/kendo-angular-layout';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { fromEvent, firstValueFrom, lastValueFrom, BehaviorSubject } from 'rxjs';
import { detect } from 'detect-browser';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';

class WrapperComponent {
    title = input();
    buttonPressed = output();
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: WrapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.2", type: WrapperComponent, selector: "app-mcl-wrapper", inputs: { title: { classPropertyName: "title", publicName: "title", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { buttonPressed: "buttonPressed" }, ngImport: i0, template: "<div class=\"appWrapper\">\r\n\r\n  <ng-content>\r\n\r\n\r\n  </ng-content>\r\n\r\n\r\n</div>\r\n", styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: WrapperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-mcl-wrapper', template: "<div class=\"appWrapper\">\r\n\r\n  <ng-content>\r\n\r\n\r\n  </ng-content>\r\n\r\n\r\n</div>\r\n" }]
        }] });

const ENVIRONMENTERTEMPLATE = new InjectionToken('Environmenter');

class MenuService {
    environmentInjection;
    router = inject(Router);
    items;
    expanded = false;
    drawerItems = {};
    showingButton = false;
    eventRan = new EventEmitter();
    selected;
    constructor(environmentInjection) {
        this.environmentInjection = environmentInjection;
    }
    getUserMenuItem(username) {
        if (username == null || username === "") {
            username = "User";
        }
        let userprofile = "???";
        if (this.environmentInjection.keycloak) {
            userprofile =
                this.environmentInjection.keycloak.url +
                    "realms/" +
                    this.environmentInjection.keycloak.realm +
                    "/account/";
        }
        return {
            text: "Welcome " + username,
            separator: false,
            icon: userIcon,
            disabled: false,
            textColor: "green",
            expanded: false,
            subItems: [
                {
                    text: "Settings",
                    separator: false,
                    icon: gearIcon,
                    disabled: false,
                    textColor: "green",
                    url: "settings",
                    subItems: null,
                },
                {
                    text: "User Profile",
                    separator: false,
                    icon: userIcon,
                    disabled: false,
                    textColor: "green",
                    url: userprofile,
                    subItems: null,
                },
                {
                    text: "Logout",
                    separator: false,
                    icon: logoutIcon,
                    disabled: false,
                    textColor: "green",
                    url: "",
                    expanded: false,
                    subItems: null,
                    level: 1,
                },
            ],
        };
    }
    setItems(menuitems, username, showUserMenu) {
        if (showUserMenu) {
            const userItem = this.getUserMenuItem(username);
            menuitems.push(userItem);
        }
        this.items = menuitems;
        this.drawerItems = this.buildDrawerItems(menuitems);
    }
    optionClicked(item) {
        if (item.url === undefined || item.url === "") {
            this.noUrlClicked(item);
        }
        else {
            if (!item.url.startsWith("http://") && !item.url.startsWith("https://")) {
                this.router.navigateByUrl(item.url).then();
            }
            else {
                this.externalLinkClicked(item.url);
            }
        }
        this.expanded = false;
    }
    noUrlClicked(indexItem) {
        this.eventRan.emit(indexItem);
    }
    buildDrawerItems(menuitems) {
        const draweritem = {};
        const parent = [];
        const child = [];
        if (menuitems == null) {
            return;
        }
        menuitems.forEach((item, index) => {
            let haschild = false;
            if (item.subItems != null) {
                item.subItems.forEach((childItem) => {
                    childItem.parentid = index;
                    childItem.level = 1;
                    child.push(childItem);
                    haschild = true;
                });
            }
            if (item != null) {
                item.level = 0;
                item.parentid = index;
                item.expanded = false;
                item.haschild = haschild;
                parent.push(item);
            }
        });
        draweritem.children = child;
        draweritem.parents = parent;
        return draweritem;
    }
    externalLinkClicked(url) {
        const link = document.createElement("a");
        link.target = "_blank";
        link.href = url;
        link.setAttribute("visibility", "hidden");
        link.click();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: MenuService, deps: [{ token: ENVIRONMENTERTEMPLATE }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: MenuService, providedIn: "root" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: MenuService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ENVIRONMENTERTEMPLATE]
                }] }] });

class HeaderComponent {
    logosource = input();
    menuService = inject(MenuService);
    menuIcon = menuIcon;
    drawerOpen() {
        this.menuService.expanded = true;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: HeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.2", type: HeaderComponent, selector: "app-mcl-header", inputs: { logosource: { classPropertyName: "logosource", publicName: "logosource", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "<div class=\"gridheader\">\r\n  <div class=\"headerWrapper\">\r\n    <div class=\"menubuttonHolder\">\r\n    <button kendoButton class=\"menuButtonPhone\" [svgIcon]=\"menuIcon\" look=\"flat\" styles=\"font-size: 18px;\" (click)=\"drawerOpen()\"> </button>\r\n    </div>\r\n    <div class=\"webLogo\">\r\n      <img [src]=\"logosource()\" alt=\"Header Image\" class=\"logoHeader\"/>\r\n    </div>\r\n    <div class=\"buttonGroup\">\r\n      <div class=\"navbar\">\r\n        <ng-content></ng-content>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "component", type: i2.ButtonComponent, selector: "button[kendoButton], span[kendoButton], kendo-button", inputs: ["arrowIcon", "toggleable", "togglable", "selected", "tabIndex", "imageUrl", "iconClass", "icon", "disabled", "size", "rounded", "fillMode", "themeColor", "svgIcon", "role", "primary", "look"], outputs: ["selectedChange", "click"], exportAs: ["kendoButton"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: HeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: "app-mcl-header", template: "<div class=\"gridheader\">\r\n  <div class=\"headerWrapper\">\r\n    <div class=\"menubuttonHolder\">\r\n    <button kendoButton class=\"menuButtonPhone\" [svgIcon]=\"menuIcon\" look=\"flat\" styles=\"font-size: 18px;\" (click)=\"drawerOpen()\"> </button>\r\n    </div>\r\n    <div class=\"webLogo\">\r\n      <img [src]=\"logosource()\" alt=\"Header Image\" class=\"logoHeader\"/>\r\n    </div>\r\n    <div class=\"buttonGroup\">\r\n      <div class=\"navbar\">\r\n        <ng-content></ng-content>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
        }] });

class FooterComponent {
    environmentInjection;
    constructor(environmentInjection) {
        this.environmentInjection = environmentInjection;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: FooterComponent, deps: [{ token: ENVIRONMENTERTEMPLATE }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.2", type: FooterComponent, selector: "app-mcl-footer", ngImport: i0, template: "<div class=\"gridfooter\">\r\n <ng-content></ng-content>\r\n</div>\r\n\r\n\r\n\r\n\r\n", styles: [".insideGridFooter{display:flex;justify-content:center;align-items:center;height:100%;width:100%}.cptext{text-align:center;color:#fff}\n"] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: FooterComponent, decorators: [{
            type: Component,
            args: [{ selector: "app-mcl-footer", template: "<div class=\"gridfooter\">\r\n <ng-content></ng-content>\r\n</div>\r\n\r\n\r\n\r\n\r\n", styles: [".insideGridFooter{display:flex;justify-content:center;align-items:center;height:100%;width:100%}.cptext{text-align:center;color:#fff}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ENVIRONMENTERTEMPLATE]
                }] }] });

class GridContentComponent {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: GridContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.2", type: GridContentComponent, selector: "app-mcl-gridcontent", ngImport: i0, template: "<div class=\"grid-content\">\r\n  <ng-content></ng-content>\r\n  <div kendoDialogContainer></div>\r\n</div>\r\n", styles: [".grid-content{background-color:#fff}\n"], dependencies: [{ kind: "directive", type: i1.DialogContainerDirective, selector: "[kendoDialogContainer]" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: GridContentComponent, decorators: [{
            type: Component,
            args: [{ selector: "app-mcl-gridcontent", template: "<div class=\"grid-content\">\r\n  <ng-content></ng-content>\r\n  <div kendoDialogContainer></div>\r\n</div>\r\n", styles: [".grid-content{background-color:#fff}\n"] }]
        }] });

var DialogType;
(function (DialogType) {
    DialogType["INFO"] = "infoDialog";
    DialogType["QUESTION"] = "questionDialog";
    DialogType["WARNING"] = "warningDialog";
    DialogType["ERROR"] = "errorDialog";
})(DialogType || (DialogType = {}));

class LoggingService {
    environmentInjection;
    production;
    constructor(environmentInjection) {
        this.environmentInjection = environmentInjection;
        this.production = environmentInjection.production;
    }
    log(message, ...optionalParams) {
        if (!this.production) {
            const logEntry = this.createLogStatement("INFO");
            console.log(logEntry, message, ...optionalParams);
            return logEntry;
        }
    }
    warn(message, ...optionalParams) {
        if (!this.production) {
            const logEntry = this.createLogStatement("WARNING");
            console.warn(logEntry, message, ...optionalParams);
            return logEntry;
        }
    }
    error(message, ...optionalParams) {
        if (!this.production) {
            const logEntry = this.createLogStatement("ERROR");
            console.error(logEntry, message, ...optionalParams);
            return logEntry;
        }
    }
    createLogStatement(level) {
        const SEPARATOR = " ";
        const date = this.getCurrentDate();
        return "[" + level + "]" + SEPARATOR + date + SEPARATOR;
    }
    getCurrentDate() {
        const now = new Date();
        return "[" + now.toLocaleString() + "]";
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: LoggingService, deps: [{ token: ENVIRONMENTERTEMPLATE }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: LoggingService, providedIn: "root" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: LoggingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ENVIRONMENTERTEMPLATE]
                }] }] });

/**
 * A Mclane wrapper over the kendo button component.
 *
 * @example
 * <app-mcl-button text="Click Me"></app-mcl-button>
 */
class McbuttonComponent {
    loading = input();
    disabled = input();
    primary = input();
    text = input();
    color = input();
    svgIcon = input();
    inprogressMessage = input("Loading");
    look = input();
    backgroundColor = input();
    borderColor = input();
    classes = input();
    buttonPressed = output();
    buttontext = this.text;
    buttonClicked() {
        this.buttonPressed.emit();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: McbuttonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.2", type: McbuttonComponent, selector: "app-mcl-button", inputs: { loading: { classPropertyName: "loading", publicName: "loading", isSignal: true, isRequired: false, transformFunction: null }, disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null }, primary: { classPropertyName: "primary", publicName: "primary", isSignal: true, isRequired: false, transformFunction: null }, text: { classPropertyName: "text", publicName: "text", isSignal: true, isRequired: false, transformFunction: null }, color: { classPropertyName: "color", publicName: "color", isSignal: true, isRequired: false, transformFunction: null }, svgIcon: { classPropertyName: "svgIcon", publicName: "svgIcon", isSignal: true, isRequired: false, transformFunction: null }, inprogressMessage: { classPropertyName: "inprogressMessage", publicName: "inprogressMessage", isSignal: true, isRequired: false, transformFunction: null }, look: { classPropertyName: "look", publicName: "look", isSignal: true, isRequired: false, transformFunction: null }, backgroundColor: { classPropertyName: "backgroundColor", publicName: "backgroundColor", isSignal: true, isRequired: false, transformFunction: null }, borderColor: { classPropertyName: "borderColor", publicName: "borderColor", isSignal: true, isRequired: false, transformFunction: null }, classes: { classPropertyName: "classes", publicName: "classes", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { buttonPressed: "buttonPressed" }, ngImport: i0, template: "<button kendoButton \r\n        [ngClass]=\"classes()\" \r\n        [style.backgroundColor]=\"backgroundColor()\" \r\n        [style.borderColor]=\"borderColor()\" \r\n        (click)=\"buttonClicked()\" \r\n        [disabled]=\"disabled()\" \r\n        [primary]=\"primary()\" \r\n        [svgIcon]=\"svgIcon()\" >\r\n  <span> {{  this.loading() ? this.inprogressMessage() : this.text() }}</span>\r\n</button>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i2.ButtonComponent, selector: "button[kendoButton], span[kendoButton], kendo-button", inputs: ["arrowIcon", "toggleable", "togglable", "selected", "tabIndex", "imageUrl", "iconClass", "icon", "disabled", "size", "rounded", "fillMode", "themeColor", "svgIcon", "role", "primary", "look"], outputs: ["selectedChange", "click"], exportAs: ["kendoButton"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: McbuttonComponent, decorators: [{
            type: Component,
            args: [{ selector: "app-mcl-button", template: "<button kendoButton \r\n        [ngClass]=\"classes()\" \r\n        [style.backgroundColor]=\"backgroundColor()\" \r\n        [style.borderColor]=\"borderColor()\" \r\n        (click)=\"buttonClicked()\" \r\n        [disabled]=\"disabled()\" \r\n        [primary]=\"primary()\" \r\n        [svgIcon]=\"svgIcon()\" >\r\n  <span> {{  this.loading() ? this.inprogressMessage() : this.text() }}</span>\r\n</button>\r\n" }]
        }] });

class ComponentsComponent {
    dialogService = inject(DialogService);
    console = inject(LoggingService);
    undoSVG = undoIcon;
    showDialog() {
        const dialog = this.dialogService.open({
            title: "Default Kendo Dialog",
            content: "This is the default color of a Kendo Dialog",
            actions: [{ text: "Cancel" }, { text: "Ok", themeColor: "primary" }],
            width: 450,
            minWidth: 250,
            cssClass: "primary-dialog",
        });
        dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                this.console.log("close");
            }
            else {
                this.console.log("action", result);
            }
        });
    }
    showConfirmDialog() {
        const dialog = this.dialogService.open({
            title: "Info",
            content: "This is a confirmation box, default color is dark blue",
            actions: [{ text: "Cancel" }, { text: "Ok", themeColor: "primary" }],
            width: 450,
            minWidth: 250,
            cssClass: "info-dialog",
        });
        // dialog.dialog.location.nativeElement.classList.add(DialogType.INFO);
        dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                this.console.log("close");
            }
            else {
                this.console.log("action", result);
            }
        });
    }
    showQuestionDialog() {
        const dialog = this.dialogService.open({
            title: "Question Dialog",
            content: "This is the typical Question confirmation box.",
            actions: [{ text: "No" }, { text: "Yes", primary: true }],
            width: 450,
            minWidth: 250,
            cssClass: "question-dialog",
        });
        dialog.dialog.location.nativeElement.classList.add(DialogType.QUESTION);
        dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                this.console.log("close");
            }
            else {
                this.console.log("action", result);
            }
        });
    }
    showWarningDialog() {
        const warningMsg = "This option should only be used if your scheduled order date is unavailable.<br/>" +
            "<br/>" +
            "Unscheduled orders may NOT be used for add-ons or to make a correction to a prior order.<br/>" +
            "Any changes must be communicated directly to your regional distribution center.<br/><br/>" +
            "If you are unsure of how to use this option, please contact the SourceLink&reg; Support.<br/>" +
            "Center toll-free at 1-800-543-3333.<br/>";
        const dialog = this.dialogService.open({
            title: "Warning Dialog",
            content: warningMsg,
            actions: [{ text: "Cancel" }, { text: "Ok", primary: true }],
            width: 450,
            minWidth: 250,
            cssClass: "warning-dialog",
        });
        // dialog.dialog.location.nativeElement.classList.add(DialogType.WARNING);
        dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                this.console.log("close");
            }
            else {
                this.console.log("action", result);
            }
        });
    }
    showErrorDialog() {
        const errorMsg = "<b>Error code:</b> -818<br/>" +
            "<br/>" +
            "<b>Error message:</b> INVALID TIMESTAMP FORMAT<br/>" +
            "<br/>" +
            "<b>If this problem persists, please call the McLane help desk.</b><br/>" +
            '<font size="1px"><b>SplunkID:</b> <a href="https://www.splunk.com" target="_blank">804.1F3</a></font>';
        const dialog = this.dialogService.open({
            title: "An unexpected database error occurred",
            content: errorMsg,
            actions: [{ text: "Cancel" }, { text: "Ok", primary: true }],
            width: 450,
            minWidth: 250,
            cssClass: "error-dialog",
        });
        // dialog.dialog.location.nativeElement.classList.add(DialogType.ERROR);
        dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                this.console.log("close");
            }
            else {
                this.console.log("action", result);
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ComponentsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.2", type: ComponentsComponent, selector: "app-components", ngImport: i0, template: "<p>Confirm Popup Samples Example</p>\r\n<div class=\"space\">\r\n\r\n  <button kendoButton (click)=\"showDialog()\">\r\n    Normal\r\n  </button>\r\n\r\n  <button kendoButton (click)=\"showConfirmDialog( )\">\r\n    Confirm\r\n  </button>\r\n\r\n  <button kendoButton (click)=\"showQuestionDialog( )\">\r\n    Question\r\n  </button>\r\n\r\n  <button kendoButton (click)=\"showWarningDialog( )\">\r\n    Warning\r\n  </button>\r\n\r\n  <button kendoButton (click)=\"showErrorDialog( )\">\r\n    Error\r\n  </button>\r\n\r\n  <app-mcl-button text=\"Test\" color=\"red\" [svgIcon]=\"undoSVG\" [loading]=\"false\" borderColor=\"red\"\r\n    backgroundColor=\"orange\"></app-mcl-button>\r\n</div>\r\n\r\n<div kendoDialogContainer></div>", styles: [".space{display:flex;flex-direction:row;gap:5px}\n"], dependencies: [{ kind: "directive", type: i1.DialogContainerDirective, selector: "[kendoDialogContainer]" }, { kind: "component", type: i2.ButtonComponent, selector: "button[kendoButton], span[kendoButton], kendo-button", inputs: ["arrowIcon", "toggleable", "togglable", "selected", "tabIndex", "imageUrl", "iconClass", "icon", "disabled", "size", "rounded", "fillMode", "themeColor", "svgIcon", "role", "primary", "look"], outputs: ["selectedChange", "click"], exportAs: ["kendoButton"] }, { kind: "component", type: McbuttonComponent, selector: "app-mcl-button", inputs: ["loading", "disabled", "primary", "text", "color", "svgIcon", "inprogressMessage", "look", "backgroundColor", "borderColor", "classes"], outputs: ["buttonPressed"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ComponentsComponent, decorators: [{
            type: Component,
            args: [{ selector: "app-components", template: "<p>Confirm Popup Samples Example</p>\r\n<div class=\"space\">\r\n\r\n  <button kendoButton (click)=\"showDialog()\">\r\n    Normal\r\n  </button>\r\n\r\n  <button kendoButton (click)=\"showConfirmDialog( )\">\r\n    Confirm\r\n  </button>\r\n\r\n  <button kendoButton (click)=\"showQuestionDialog( )\">\r\n    Question\r\n  </button>\r\n\r\n  <button kendoButton (click)=\"showWarningDialog( )\">\r\n    Warning\r\n  </button>\r\n\r\n  <button kendoButton (click)=\"showErrorDialog( )\">\r\n    Error\r\n  </button>\r\n\r\n  <app-mcl-button text=\"Test\" color=\"red\" [svgIcon]=\"undoSVG\" [loading]=\"false\" borderColor=\"red\"\r\n    backgroundColor=\"orange\"></app-mcl-button>\r\n</div>\r\n\r\n<div kendoDialogContainer></div>", styles: [".space{display:flex;flex-direction:row;gap:5px}\n"] }]
        }] });

class HeaderMenuComponent {
    router = inject(Router);
    menuService = inject(MenuService);
    console = inject(LoggingService);
    cd = inject(ChangeDetectorRef);
    menuItems = [];
    backgroundColor = input();
    borderColor = input();
    menuClicked = output();
    noUrlClicked(item) {
        this.menuClicked.emit(item);
    }
    menuItemClicked(item) {
        let main = null;
        let second;
        try {
            const str = item.index.toString();
            const arr = str.split("_");
            main = arr[0];
            second = arr[1];
        }
        catch (e) {
            console.log(e);
            second = undefined;
        }
        const filteredItems = this.menuService.items;
        let indexItem = filteredItems[main];
        if (second !== undefined) {
            indexItem = filteredItems[main].subItems[second];
        }
        this.menuService.optionClicked(indexItem);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: HeaderMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.2", type: HeaderMenuComponent, selector: "app-mcl-headermenu", inputs: { backgroundColor: { classPropertyName: "backgroundColor", publicName: "backgroundColor", isSignal: true, isRequired: false, transformFunction: null }, borderColor: { classPropertyName: "borderColor", publicName: "borderColor", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { menuClicked: "menuClicked" }, ngImport: i0, template: "<kendo-menu (select)=\"menuItemClicked($event)\" [kendoMenuHierarchyBinding]=\"menuService.items\" childrenField=\"subItems\" [textField]=\"['text']\">\r\n  <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n    <kendo-svg-icon *ngIf=\"item.data.icon\" [icon]=\"item.data.icon\" size=\"large\"></kendo-svg-icon>\r\n    <span *ngIf=\"!item.data.iconOnly\" >\r\n      {{item.text}}\r\n    </span>\r\n  </ng-template>\r\n</kendo-menu>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.MenuComponent, selector: "kendo-menu", inputs: ["appendTo", "menuItemTemplate", "ariaRole", "menuItemLinkTemplate"], outputs: ["select", "open", "close"], exportAs: ["kendoMenu"] }, { kind: "directive", type: i2$1.ItemTemplateDirective, selector: "[kendoMenuItemTemplate]" }, { kind: "directive", type: i2$1.HierarchyBindingDirective, selector: "[kendoMenuHierarchyBinding]", inputs: ["kendoMenuHierarchyBinding", "textField", "urlField", "iconField", "svgIconField", "disabledField", "cssClassField", "cssStyleField", "separatorField", "childrenField"], exportAs: ["kendoMenuHierarchyBinding"] }, { kind: "component", type: i3.SVGIconComponent, selector: "kendo-svg-icon, kendo-svgicon", inputs: ["icon"], exportAs: ["kendoSVGIcon"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: HeaderMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: "app-mcl-headermenu", template: "<kendo-menu (select)=\"menuItemClicked($event)\" [kendoMenuHierarchyBinding]=\"menuService.items\" childrenField=\"subItems\" [textField]=\"['text']\">\r\n  <ng-template kendoMenuItemTemplate let-item=\"item\">\r\n    <kendo-svg-icon *ngIf=\"item.data.icon\" [icon]=\"item.data.icon\" size=\"large\"></kendo-svg-icon>\r\n    <span *ngIf=\"!item.data.iconOnly\" >\r\n      {{item.text}}\r\n    </span>\r\n  </ng-template>\r\n</kendo-menu>\r\n" }]
        }] });

class MenuDrawerComponent {
    menuService = inject(MenuService);
    router = inject(Router);
    console = inject(LoggingService);
    mode = input("overlay");
    smallSidebar = input(false);
    titleHeader = input("Welcome");
    menuClicked = output();
    sideDrawerPosition = input("start");
    items = undefined;
    itemIndex;
    ngOnInit() {
        this.items = this.menuService.items;
    }
    onSelect(ev) {
        this.menuService.selected = ev.item.text;
        if (this.menuService.drawerItems.parents[ev.index].haschild === true) {
            const item = this.menuService.drawerItems.parents[ev.index];
            item.expanded = !item.expanded;
            this.itemIndex = ev.index;
            const childItems = this.menuService.drawerItems.children.filter((childitem) => {
                return childitem.parentid === item.parentid;
            });
            if (item.expanded) {
                this.addChildren(childItems);
            }
            else {
                this.removeChildren(childItems);
            }
        }
        else {
            const item = ev.item;
            const index = ev.index;
            item.index = index;
            this.menuService.optionClicked(item);
        }
    }
    addChildren(children) {
        this.menuService.drawerItems.parents.splice(this.itemIndex + 1, 0, ...children);
    }
    removeChildren(children) {
        this.console.log("children", children);
        if (children != null) {
            this.menuService.drawerItems.parents.splice(this.itemIndex + 1, children.length);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: MenuDrawerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.2", type: MenuDrawerComponent, selector: "app-mcl-menudrawer", inputs: { mode: { classPropertyName: "mode", publicName: "mode", isSignal: true, isRequired: false, transformFunction: null }, smallSidebar: { classPropertyName: "smallSidebar", publicName: "smallSidebar", isSignal: true, isRequired: false, transformFunction: null }, titleHeader: { classPropertyName: "titleHeader", publicName: "titleHeader", isSignal: true, isRequired: false, transformFunction: null }, sideDrawerPosition: { classPropertyName: "sideDrawerPosition", publicName: "sideDrawerPosition", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { menuClicked: "menuClicked" }, ngImport: i0, template: "<kendo-drawer-container>\r\n\r\n  <kendo-drawer #drawer\r\n                class=\"\"\r\n                [items]=\"this.menuService.drawerItems.parents\"\r\n                [mini]=\"smallSidebar()\"\r\n                [mode]=\"mode()\"\r\n                [width]=\"400\"\r\n                [autoCollapse]=\"false\"\r\n                [position]=\"sideDrawerPosition()\"\r\n                [(expanded)]=\"menuService.expanded\"\r\n                (select)=\"onSelect($event)\">\r\n    <ng-template kendoDrawerHeaderTemplate>\r\n      <div *ngIf=\"menuService.expanded\" class=\"headerSmall\" style=\"text-align: center;\">\r\n        <span class=\"menuCloseButton\">\r\n          <span class=\"k-icon k-font-icon k-i-close-outline\" (click)=\"drawer.toggle()\"></span>\r\n        </span>\r\n        <h4>{{titleHeader()}}</h4>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template kendoDrawerItemTemplate let-item >\r\n\r\n      <div *ngIf=\"!item.hide\" [ngClass]=\"{'gone' : item.hide == true, 'sidedrawerhide': item.drawerItemDisplay == true}\"  class=\"sidedrawerholder\">\r\n\r\n      <div  class=\"k-level-{{ item.level }}\" >\r\n        <kendo-svgicon *ngIf=\"item.icon\" [icon]=\"item.icon\"></kendo-svgicon>\r\n      </div>\r\n        <span>\r\n      {{ item.text }}\r\n        </span>\r\n      <span\r\n        *ngIf=\"item.expanded && item.haschild\"\r\n        class=\"k-icon k-font-icon k-i-arrow-chevron-down\"\r\n        style=\"position:absolute; right:0; line-height: inherit\"\r\n      ></span>\r\n\r\n      <span\r\n        *ngIf=\"!item.expanded && item.haschild\"\r\n        class=\"k-icon k-font-icon k-i-arrow-chevron-right\"\r\n        style=\"position:absolute; right:0; line-height: inherit\"\r\n      ></span>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template kendoDrawerFooterTemplate>\r\n\r\n    </ng-template>\r\n  </kendo-drawer>\r\n\r\n  <kendo-drawer-content>\r\n   <app-mcl-gridcontent>\r\n     <ng-content></ng-content>\r\n   </app-mcl-gridcontent>\r\n  </kendo-drawer-content>\r\n</kendo-drawer-container>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$2.DrawerComponent, selector: "kendo-drawer", inputs: ["mode", "position", "mini", "expanded", "width", "miniWidth", "autoCollapse", "items", "isItemExpanded", "animation"], outputs: ["expand", "collapse", "select", "expandedChange"], exportAs: ["kendoDrawer"] }, { kind: "component", type: i2$2.DrawerContainerComponent, selector: "kendo-drawer-container" }, { kind: "component", type: i2$2.DrawerContentComponent, selector: "kendo-drawer-content" }, { kind: "directive", type: i2$2.DrawerFooterTemplateDirective, selector: "[kendoDrawerFooterTemplate]" }, { kind: "directive", type: i2$2.DrawerHeaderTemplateDirective, selector: "[kendoDrawerHeaderTemplate]" }, { kind: "directive", type: i2$2.DrawerItemTemplateDirective, selector: "[kendoDrawerItemTemplate]" }, { kind: "component", type: i3.SVGIconComponent, selector: "kendo-svg-icon, kendo-svgicon", inputs: ["icon"], exportAs: ["kendoSVGIcon"] }, { kind: "component", type: GridContentComponent, selector: "app-mcl-gridcontent" }], encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: MenuDrawerComponent, decorators: [{
            type: Component,
            args: [{ selector: "app-mcl-menudrawer", encapsulation: ViewEncapsulation.None, template: "<kendo-drawer-container>\r\n\r\n  <kendo-drawer #drawer\r\n                class=\"\"\r\n                [items]=\"this.menuService.drawerItems.parents\"\r\n                [mini]=\"smallSidebar()\"\r\n                [mode]=\"mode()\"\r\n                [width]=\"400\"\r\n                [autoCollapse]=\"false\"\r\n                [position]=\"sideDrawerPosition()\"\r\n                [(expanded)]=\"menuService.expanded\"\r\n                (select)=\"onSelect($event)\">\r\n    <ng-template kendoDrawerHeaderTemplate>\r\n      <div *ngIf=\"menuService.expanded\" class=\"headerSmall\" style=\"text-align: center;\">\r\n        <span class=\"menuCloseButton\">\r\n          <span class=\"k-icon k-font-icon k-i-close-outline\" (click)=\"drawer.toggle()\"></span>\r\n        </span>\r\n        <h4>{{titleHeader()}}</h4>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template kendoDrawerItemTemplate let-item >\r\n\r\n      <div *ngIf=\"!item.hide\" [ngClass]=\"{'gone' : item.hide == true, 'sidedrawerhide': item.drawerItemDisplay == true}\"  class=\"sidedrawerholder\">\r\n\r\n      <div  class=\"k-level-{{ item.level }}\" >\r\n        <kendo-svgicon *ngIf=\"item.icon\" [icon]=\"item.icon\"></kendo-svgicon>\r\n      </div>\r\n        <span>\r\n      {{ item.text }}\r\n        </span>\r\n      <span\r\n        *ngIf=\"item.expanded && item.haschild\"\r\n        class=\"k-icon k-font-icon k-i-arrow-chevron-down\"\r\n        style=\"position:absolute; right:0; line-height: inherit\"\r\n      ></span>\r\n\r\n      <span\r\n        *ngIf=\"!item.expanded && item.haschild\"\r\n        class=\"k-icon k-font-icon k-i-arrow-chevron-right\"\r\n        style=\"position:absolute; right:0; line-height: inherit\"\r\n      ></span>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template kendoDrawerFooterTemplate>\r\n\r\n    </ng-template>\r\n  </kendo-drawer>\r\n\r\n  <kendo-drawer-content>\r\n   <app-mcl-gridcontent>\r\n     <ng-content></ng-content>\r\n   </app-mcl-gridcontent>\r\n  </kendo-drawer-content>\r\n</kendo-drawer-container>\r\n" }]
        }] });

class ResizeService {
    console = inject(LoggingService);
    length = 0;
    width = 0;
    screenChange = new EventEmitter();
    resizeObservable$;
    constructor() {
        this.resizeObservable$ = fromEvent(window, "resize");
        this.length = window.innerHeight;
        this.width = window.innerWidth;
        this.console.log(this.width);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ResizeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ResizeService, providedIn: "root" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ResizeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: () => [] });

class SettingsComponent {
    env;
    browser = detect();
    appVersion;
    deviceType;
    browserName;
    browserVersion;
    osType;
    constructor(env) {
        this.env = env;
        this.appVersion = env.version;
        this.deviceType = this.browser.type;
        this.browserName = this.browser.name;
        this.browserVersion = this.browser.version;
        this.osType = this.browser.os;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: SettingsComponent, deps: [{ token: ENVIRONMENTERTEMPLATE }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.2", type: SettingsComponent, selector: "app-mcl-settings", ngImport: i0, template: "<div class=\"center-container\">\r\n  <div class=\"container\">\r\n    <div class=\"settings-heading\">\r\n      <p>Device Information</p>\r\n    </div>\r\n    <div class=\"device-container\">\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Device Type:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">\r\n              {{deviceType | titlecase}}\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Browser Name:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">{{browserName | titlecase}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Browser Version:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">{{browserVersion}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div>\r\n            <p>Operating System:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div>\r\n            <p class=\"setting-data\">{{osType}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"settings-heading\">\r\n      <p>Application Information</p>\r\n    </div>\r\n\r\n\r\n    <div class=\"device-container\">\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Version:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">{{appVersion}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Target:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">{{env.target}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Production:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">{{env.production ? 'True' : 'False'}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".center-container{display:flex;justify-content:center}.container{display:flex;flex-direction:column;width:50vw;margin-left:20px;min-height:100px}.settings-heading p{font-weight:700;font-size:18px}.device-container,.version-container,.environment-container{padding-left:5px;background-color:#fff}.row{display:flex;flex-direction:row;flex-wrap:wrap;width:100%}.column{display:flex;flex-direction:column;flex-basis:100%;flex:1}.setting-data{float:right;padding-right:5px}.border-bottom{border-bottom:1px solid #e6e6e6}.settings-button-container{margin-top:5px;margin-bottom:5px;margin-right:5px;float:right}.settings-button{background-image:linear-gradient(#005bbb99,#005bbb);width:50%;color:#fff}\n"], dependencies: [{ kind: "pipe", type: i1$1.TitleCasePipe, name: "titlecase" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: SettingsComponent, decorators: [{
            type: Component,
            args: [{ selector: "app-mcl-settings", template: "<div class=\"center-container\">\r\n  <div class=\"container\">\r\n    <div class=\"settings-heading\">\r\n      <p>Device Information</p>\r\n    </div>\r\n    <div class=\"device-container\">\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Device Type:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">\r\n              {{deviceType | titlecase}}\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Browser Name:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">{{browserName | titlecase}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Browser Version:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">{{browserVersion}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div>\r\n            <p>Operating System:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div>\r\n            <p class=\"setting-data\">{{osType}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"settings-heading\">\r\n      <p>Application Information</p>\r\n    </div>\r\n\r\n\r\n    <div class=\"device-container\">\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Version:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">{{appVersion}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Target:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">{{env.target}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class='row'>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p>Production:</p>\r\n          </div>\r\n        </div>\r\n        <div class='column'>\r\n          <div class=\"border-bottom\">\r\n            <p class=\"setting-data\">{{env.production ? 'True' : 'False'}}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".center-container{display:flex;justify-content:center}.container{display:flex;flex-direction:column;width:50vw;margin-left:20px;min-height:100px}.settings-heading p{font-weight:700;font-size:18px}.device-container,.version-container,.environment-container{padding-left:5px;background-color:#fff}.row{display:flex;flex-direction:row;flex-wrap:wrap;width:100%}.column{display:flex;flex-direction:column;flex-basis:100%;flex:1}.setting-data{float:right;padding-right:5px}.border-bottom{border-bottom:1px solid #e6e6e6}.settings-button-container{margin-top:5px;margin-bottom:5px;margin-right:5px;float:right}.settings-button{background-image:linear-gradient(#005bbb99,#005bbb);width:50%;color:#fff}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ENVIRONMENTERTEMPLATE]
                }] }] });

class MCdialogService {
    router = inject(Router);
    dialogService = inject(DialogService);
    console = inject(LoggingService);
    toaster = inject(ToastrService);
    async open(options) {
        const dialog = this.dialogService.open(options);
        dialog.dialog.location.nativeElement.classList.add(options.type);
        const results = await dialog.result
            .toPromise()
            .then((response) => response);
        return results.text;
    }
    async showConfirmDialogYesNo(title, message) {
        const dialog = this.dialogService.open({
            title: title,
            content: message,
            width: 400,
            actions: [{ text: "No" }, { text: "Yes", primary: true }],
        });
        dialog.dialog.location.nativeElement.classList.add(DialogType.QUESTION);
        const results = await firstValueFrom(dialog.result).then((response) => response);
        return results.text === "Yes";
    }
    async showConfirmDialogOkCancel(title, message) {
        const dialog = this.dialogService.open({
            title: title,
            content: message,
            width: 400,
            actions: [{ text: "Cancel" }, { text: "Ok", primary: true }],
        });
        dialog.dialog.location.nativeElement.classList.add(DialogType.QUESTION);
        const results = await firstValueFrom(dialog.result).then((response) => response);
        return results.text === "Ok";
    }
    async showConfirmDialogOkOnly(title, message) {
        const dialog = this.dialogService.open({
            title: title,
            content: message,
            width: 400,
            actions: [{ text: "Ok", primary: true }],
        });
        dialog.dialog.location.nativeElement.classList.add(DialogType.QUESTION);
        const results = await firstValueFrom(dialog.result).then((response) => response);
        return results.text === "Ok";
    }
    async showOkErrorDialog(title, message) {
        const dialog = this.dialogService.open({
            title: title,
            content: message,
            width: 400,
            actions: [{ text: "Ok", primary: true }],
        });
        dialog.dialog.location.nativeElement.classList.add(DialogType.ERROR);
        const results = await firstValueFrom(dialog.result).then((response) => response);
        return results.text === "Ok";
    }
    showToastInfo(message, title) {
        this.toaster.info(message, title);
    }
    showToastError(message, title) {
        this.toaster.error(message, title);
    }
    async showRetryDialog() {
        const dialog = this.dialogService.open({
            title: "Oops!",
            content: "Sorry, Something happened on our end. Please retry your request.",
            width: 400,
            actions: [{ text: "Ok", primary: true }],
        });
        dialog.dialog.location.nativeElement.classList.add(DialogType.ERROR);
        const results = await firstValueFrom(dialog.result).then((response) => response);
        return results.text === "Ok";
        // dialog.dialog.location.nativeElement.classList.add(DialogType.ERROR);
        // dialog.result.toPromise().then(results => {
        //     if (results === 'Ok') {
        //         this.router.navigate(['/logout']).then(r => r);
        //     }
        // });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: MCdialogService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: MCdialogService, providedIn: "root" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: MCdialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }] });

class SplunkMessage {
    message;
    splid;
}

class GlobalErrorHandlerService {
    environmentInjection;
    injector = inject(Injector);
    httpClient = inject(HttpClient);
    dialogService = inject(MCdialogService);
    splunkMsg = new SplunkMessage();
    splunkErrorURL = "/util/log";
    constructor(environmentInjection) {
        this.environmentInjection = environmentInjection;
    }
    errorSplunk(error) {
        return this.handleError(error);
    }
    async handleError(error) {
        try {
            if (error !== null && error !== undefined) {
                console.error(error);
            }
            let splunkId = Math.random().toString(36).substring(2, 5);
            splunkId += ".";
            splunkId += Math.random().toString(36).substring(2, 3);
            const router = this.injector.get(Router);
            const display = " SPL.ID: " + splunkId.toUpperCase();
            const log = "SPLID.UI: " + splunkId.toUpperCase();
            // const message = error.error ? error.error : this.errorService.sanitizeMessage(error.message);
            // console.error(message);
            this.splunkMsg.splid = log + " page=" + router.url;
            this.splunkMsg.message = error.stack;
            console.log(this.splunkMsg);
            console.error(error.stack);
            lastValueFrom(this.generateSplunkId(this.splunkMsg))
                .then((r) => console.log(r))
                .catch((e) => console.log(e));
            // TODO clean up logic with error dialogs
            if (this.dialogService !== undefined) {
                this.dialogService
                    .open({
                    type: DialogType.ERROR,
                    title: "Unexpected Error!",
                    content: "An unexpected error occurred: " + "\n" + display,
                    actions: [{ text: "Ok", primary: true }],
                    width: 400,
                })
                    .then((r) => r);
            }
            else {
                alert("An unexpected error occurred. Please contact McLane Helpdesk." +
                    display);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    generateSplunkId(splunkMsg) {
        const json = JSON.stringify(splunkMsg);
        return this.httpClient.post(this.environmentInjection.supportServicePrefix + this.splunkErrorURL, json);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: GlobalErrorHandlerService, deps: [{ token: ENVIRONMENTERTEMPLATE }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: GlobalErrorHandlerService, providedIn: "root" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: GlobalErrorHandlerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ENVIRONMENTERTEMPLATE]
                }] }] });

class ApptemplateLibModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ApptemplateLibModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.2", ngImport: i0, type: ApptemplateLibModule, declarations: [WrapperComponent,
            HeaderComponent,
            FooterComponent,
            GridContentComponent,
            ComponentsComponent,
            McbuttonComponent,
            HeaderMenuComponent,
            MenuDrawerComponent,
            SettingsComponent], imports: [DialogModule,
            CommonModule,
            ButtonModule,
            BrowserModule,
            BrowserAnimationsModule,
            MenuModule,
            RouterModule,
            LayoutModule,
            IconModule,
            SVGIconModule], exports: [WrapperComponent,
            HeaderComponent,
            FooterComponent,
            ButtonModule,
            MenuModule,
            GridContentComponent,
            McbuttonComponent,
            HeaderMenuComponent,
            LayoutModule,
            MenuDrawerComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ApptemplateLibModule, providers: [
            MenuService,
            ResizeService,
            LoggingService,
            MCdialogService,
            GlobalErrorHandlerService,
        ], imports: [DialogModule,
            CommonModule,
            ButtonModule,
            BrowserModule,
            BrowserAnimationsModule,
            MenuModule,
            RouterModule,
            LayoutModule,
            IconModule,
            SVGIconModule, ButtonModule,
            MenuModule,
            LayoutModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ApptemplateLibModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        WrapperComponent,
                        HeaderComponent,
                        FooterComponent,
                        GridContentComponent,
                        ComponentsComponent,
                        McbuttonComponent,
                        HeaderMenuComponent,
                        MenuDrawerComponent,
                        SettingsComponent,
                    ],
                    imports: [
                        DialogModule,
                        CommonModule,
                        ButtonModule,
                        BrowserModule,
                        BrowserAnimationsModule,
                        MenuModule,
                        RouterModule,
                        LayoutModule,
                        IconModule,
                        SVGIconModule,
                    ],
                    exports: [
                        WrapperComponent,
                        HeaderComponent,
                        FooterComponent,
                        ButtonModule,
                        MenuModule,
                        GridContentComponent,
                        McbuttonComponent,
                        HeaderMenuComponent,
                        LayoutModule,
                        MenuDrawerComponent,
                    ],
                    providers: [
                        MenuService,
                        ResizeService,
                        LoggingService,
                        MCdialogService,
                        GlobalErrorHandlerService,
                    ],
                }]
        }] });

class LoadingIndicator {
    isLoading = new BehaviorSubject(false);
    loaderActive;
    constructor() {
        this.isLoading = new BehaviorSubject(true);
    }
    show() {
        return setTimeout(() => {
            this.isLoading.next(true);
        });
    }
    hide() {
        return setTimeout(() => {
            this.isLoading.next(false);
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: LoadingIndicator, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: LoadingIndicator, providedIn: "root" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: LoadingIndicator, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: () => [] });

/**
 * Generated bundle index. Do not edit.
 */

export { ApptemplateLibModule, ENVIRONMENTERTEMPLATE, FooterComponent, GlobalErrorHandlerService, GridContentComponent, HeaderComponent, HeaderMenuComponent, LoadingIndicator, LoggingService, MCdialogService, McbuttonComponent, MenuDrawerComponent, MenuService, ResizeService, SettingsComponent, SplunkMessage, WrapperComponent };
